import { Module } from 'vuex-module-decorators';
import store from '@/store';
import FilterModule from '@/store/filter';

@Module({ dynamic: true, store, name: 'administratorsFilter', namespaced: true })
export default class AdministratorsFilter extends FilterModule {
    constructor(module: AdministratorsFilter) {
        super(module);
    }
}
